export const getSelectOptionLabel = (option: { label: string }) => option.label;
